export const ObjToQueryString = (queryParams) => {
  const keyValuePairs = [];

  if (queryParams === undefined) {
    return '';
  }

  for (const key in queryParams) {
    if (queryParams.hasOwnProperty(key)) {
      keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(queryParams[key]));
    }
  }
  return Object.keys(queryParams).length !== 0 ? ('?' + keyValuePairs.join('&')) : '';
};
